module.exports = __webpack_public_path__ + "static/media/bannerDesktop@1x.792d7ac3.jpg";